import { ReactNode } from "react";
import { CharterType, CommentEntityType } from "__generated__/enums";
import { CommentFragment } from "__generated__/graphql/fragments.generated";
import { SessionState } from "ezStore";

export interface CommentableEntity {
	id: number;
	name: string;
	title: ReactNode;
	type: CommentEntityType;
	comments: CommentFragment[]
}

export interface SelectedCommentableEntity {
    id: number;
    type: CommentEntityType;
}

export interface CommentableTarget {
    id: number;
    comments?: CommentFragment[] | null;
}

export interface CommentCargo extends CommentableTarget {
	cargoNumber?: string | null;
	containerNumber?: string | null;
	comments?: CommentFragment[] | null;
	product?: {
		id: number;
		name: string;
		description?: string | null;
	} | null;
	charter?: {
		id: number;
		charterNumber: string;
		type: CharterType;
	} | null
}

export interface CommentCall extends CommentableTarget {
	location?: {
		id: number;
		description: string;
	} | null;
	voyage?: {
		id: number;
		voyageNumber: string;
	} | null;
}

export interface CommentContract extends CommentableTarget {
	contractNumber: string;
}

export function hasUnreadComments(comments: CommentFragment[], readComments: SessionState["readComments"]) {
	const unreadComments = [ ...comments ].filter(c => !readComments.comments.find(co => co.id === c.id));
	const hasRelevantUnread = unreadComments.some(c => c.created > readComments.date);
	return hasRelevantUnread;
}

export function buildGroups(entities: CommentableEntity[]) {
	return entities.reduce<{ [key in CommentEntityType]: CommentableEntity[] }>((result: { [key in CommentEntityType]: CommentableEntity[] }, entity: CommentableEntity) => {
		result[entity.type].push(entity);
		return result;
	}, {
		[CommentEntityType.Cargo]: [],
		[CommentEntityType.Contract]: [],
		[CommentEntityType.Call]: [],
	});
}
